/**
 * Shortlist Store
 *
 * Manages product shortlist state in localStorage.
 * HR teams shortlist 10-15 products before narrowing down.
 * No auth required — purely local working tool.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ShortlistItem {
  productId: string;
  name: string;
  slug: string;
  image: string | null;
  addedAt: number;
}

interface ShortlistState {
  items: ShortlistItem[];
  addItem: (item: Omit<ShortlistItem, 'addedAt'>) => void;
  removeItem: (productId: string) => void;
  isInShortlist: (productId: string) => boolean;
  clearAll: () => void;
  getCount: () => number;
}

export const useShortlistStore = create<ShortlistState>()(
  persist(
    (set, get) => ({
      items: [],

      addItem: (item) =>
        set((state) => {
          if (state.items.some((i) => i.productId === item.productId)) {
            return state; // Already in shortlist
          }
          return {
            items: [...state.items, { ...item, addedAt: Date.now() }],
          };
        }),

      removeItem: (productId) =>
        set((state) => ({
          items: state.items.filter((i) => i.productId !== productId),
        })),

      isInShortlist: (productId) =>
        get().items.some((i) => i.productId === productId),

      clearAll: () => set({ items: [] }),

      getCount: () => get().items.length,
    }),
    {
      name: 'gifting-shortlist',
    }
  )
);
